export default __webpack_public_path__ + "static/media/total-cases.63ff06c3.svg";